import React, {Component} from 'react';
import {Button, Form, Input, Grid, Header, Icon, Image, Modal, Popup, Segment,Divider, Message,List} from 'semantic-ui-react';
import ReportContainer from "../../containers/report_container";
import { uploadTranscription} from "../../data/report_api";
import Loader from "../universal/loader";
import { getHeader } from '../../data/user_api';

const uuidv1 = require('uuid/v1');

class COTranscriptionSticky extends Component {

    constructor(props) {
        super(props);
        this.state = {
            comparisonList:undefined,
            expanded:true,
            itemNumber:undefined,
            horizExpanded:false
        }
    }
    // componentWillMount() {
    // }
    uploadTranscription = async () => {
        this.setState({loading:true, errorMessage:undefined})
        let formData = new FormData()
        formData.append("file", this.state.audioFile)
        formData.append("report_id", this.props.reportDetails["id"])
        let response = await uploadTranscription(formData)
        if (response.success) {
            this.setState({transcriptionText:response.transcriptionText, comparisonList:response.transcriptionText.split("."), currentStep:2})
        } else {
            this.setState({errorMessage:response.statusMessage})
        }
        this.setState({loading:false})
    }

    render() {
        const comparisonStyle = {height:"400px", width:this.state.horizExpanded? "450px" : "250px", overflow:"scroll"}
        return (<Segment style={{zIndex:"999"}}id="transcriptionView">
            <Header>Audio Transcription
        <Icon size="small" className="icon-button pull-right" onClick={()=>{this.setState({expanded:!this.state.expanded})}} name={this.state.expanded ?"compress":"expand"}/>
        <Icon size="small" className="icon-button pull-right" onClick={()=>{this.setState({horizExpanded:!this.state.horizExpanded})}} name={this.state.horizExpanded?"triangle right":"triangle left"}/>
        <Icon size="small" className="icon-button pull-right" onClick={()=>{Object.assign(document.createElement('a'), { target: '_blank', href: "https://youtu.be/uOKSMPwQnAc"}).click()}} name="question"/>
            </Header>
                 {this.state.expanded && <div>
                    {!this.state.comparisonList && <Form>
        <Form.Group>
            <Form.Field inline >
                <label>Audio File</label>
                <Input
                    type="file"
                    required
                    accept="audio/*"
                    ref="addAudio"
                    onChange={(e) => {
                        if (e.target.files[0].size > 26214400){
                            this.props.logErrorResponse('ERROR: File size over 26 MB, please compress audio or split it into multiple parts. You can google "compress/split audio file" for several sites that can help with this')
                        } else {
                            
                            this.setState({audioFile:e.target.files[0], errorMessage:undefined})
                        }
                    }}
                />
            </Form.Field>
            <Form.Field>
            <Button primary onClick={()=>{this.uploadTranscription()}} loading={this.state.loading} disabled={!this.state.audioFile ||this.state.loading || this.state.transcriptionText}>Transcribe</Button>
            </Form.Field>
        </Form.Group>
            </Form>}




            {this.state.comparisonList &&  <Segment style={{width:this.state.horizExpanded? "450px":"250px"}}>
                   <Form onSubmit={()=>this.props.jumpToItem(this.state.itemNumber)}>
            <Form.Field >
                <label>Go To Item #</label>
                <Input 
                onChange={e=>this.setState({itemNumber:e.target.value})}
                    type="number"
                />
            </Form.Field>
            </Form></Segment>}
                  {this.state.comparisonList && <Segment style={{...comparisonStyle}}>{this.state.comparisonList.map((word, index) =>{return <Message key={index} warning={index%2 == 0}>{word}</Message>})}</Segment>
                 }
                  </div>}
        </Segment>);
    }

}

export default ReportContainer(COTranscriptionSticky);


// WEBPACK FOOTER //
// ./src/views/report/co_transcription_sticky.js